import React from 'react';
import ReactDOM from 'react-dom';
import ModalToast from './component';

const show_toast = props => {
    let component = null;
    const lastEle = document.getElementById('toastModal');

    if (lastEle) {
        lastEle.parentElement.removeChild(lastEle); // 删除上一次的弹窗
    }
    const div = document.createElement('div');

    div.setAttribute('id', 'toastModal');
    document.body.appendChild(div);

    const onClose = () => {
        if (div) {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentElement) div.parentElement.removeChild(div);
        }

        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    };

    ReactDOM.render(
        /* eslint-disable */
        <ModalToast {...props} onClose={onClose} ref={c => (component = c)} isOpen>
            {props.content}
        </ModalToast>,
        div,
    );
};

const Toast = {};

Toast.success = props =>
    show_toast({
        ...props,
        type: 'success',
    });
Toast.warning = props =>
    show_toast({
        ...props,
        type: 'warning',
    });

Toast.default = props =>
    show_toast({
        ...props,
        type: 'default',
    });

export default Toast;
